type ItemQuery = { id: number; cantidad: number };

export const parseItemsQuery = (items?: string): ItemQuery[] => {
  if (!items) return [];
  return items
    .split(',')
    .map((par) => {
      const [id, cantidad] = par.split(':').map(Number);
      return { id, cantidad };
    })
    .filter((item) => Number.isFinite(item.id) && Number.isFinite(item.cantidad) && item.cantidad > 0);
};

export const buildItemsQuery = (productos: { producto: { id: number }; cantidad: number }[]): string =>
  productos.map((item) => `${item.producto.id}:${item.cantidad}`).join(',');
